import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {OptInMarketingSearchData} from "./opt-in-marketing-search.data";

@Injectable()
export class OptInMarketingSearchModel extends SearchModel<OptInMarketingSearchData> {

    constructor(injector: Injector) {
        super(injector)
    }

    override getIdentifierField(): string {
        return "id";
    }
}
